import { useState, useEffect } from 'react'
// redux
import { useSelector } from 'react-redux'
// router
import { useLocation } from 'react-router-dom'
// hooks
import useUIActions from './useUIActions'
// utils
import isIOS from 'utils/isIOS'
import sendGaPush from 'utils/sendGaPush'
// components
// import Modal from 'components/atoms/modal/modal'
// import InstallModal from 'components/organisms/install-modal/install-modal'

export default function useInstalledApp() {
	// redux
	const { installPrompt } = useSelector(state => state.elementsUI)
	// const { registrationDate } = useSelector(state => state.session)

	// hooks
	const { initSetInstallPrompt, handleCloseModal } = useUIActions() // handleShowModal removed from destructuring

	// location
	const { pathname } = useLocation()
	const isParQPublicPath = pathname.includes('/par-q-public')

	// data
	const [isInstallApp, setIsInstallApp] = useState(false) // Default to false
	const [iosImage, setIosImage] = useState(false)

	const [isInstalling, setIsInstalling] = useState(false)
	const [installCompleted, setInstallCompleted] = useState(false)

	const handleInstall = value => {
		setIsInstallApp(value)
		// Removed localStorage.setItem('IS_INSTALL_APP', value)
	}

	// values
	const isInstalledAndroid = window.matchMedia('(display-mode: standalone)').matches

	// validate if allow install app
	const getAllowInstallation = () => {
		if (isParQPublicPath) return null

		const beforeInstallHandler = e => {
			// Verify event origin
			if (!e || !e.isTrusted) {
				console.warn('Evento beforeinstallprompt no confiable ignorado')
				return
			}

			e.preventDefault()

			// Verify that the event comes from the same origin
			if (e.origin && e.origin !== window.location.origin) {
				console.warn('Origen del evento no coincide')
				return
			}

			initSetInstallPrompt(e)
			localStorage.setItem('PROMPT', JSON.stringify(e))
			handleInstall(false)
		}

		window.addEventListener('beforeinstallprompt', beforeInstallHandler)
		return beforeInstallHandler
	}

	const getWasInstalled = () => {
		const appInstalledHandler = e => {
			// Verify event origin
			if (!e || !e.isTrusted) {
				console.warn('Evento appinstalled no confiable ignorado')
				return
			}

			// Verify that the event comes from the same origin
			if (e.origin && e.origin !== window.location.origin) {
				console.warn('Origen del evento no coincide')
				return
			}

			// No need to prevent default for appinstalled event
			handleInstall(true)
			setInstallCompleted(true)
		}

		window.addEventListener('appinstalled', appInstalledHandler)
		return appInstalledHandler
	}

	const listenMatchMedia = () => {
		if (typeof window === 'undefined') return

		if (!window.matchMedia) return

		const mediaQuery = '(display-mode: standalone)'
		const mediaQueryList = window.matchMedia(mediaQuery)

		const handleDisplayModeChange = evt => {
			if (!evt || evt.isTrusted !== true) {
				console.warn('Evento no confiable ignorado')
				return
			}

			let displayMode = 'browser'
			if (evt.matches) {
				displayMode = 'standalone'
			}

			handleInstall(displayMode === 'standalone')
		}

		// Corrected: addEventListener in one word
		mediaQueryList.addEventListener('change', handleDisplayModeChange)

		return () => {
			mediaQueryList.removeEventListener('change', handleDisplayModeChange)
		}
	}

	// install command
	const installApp = async () => {
		if (!isIOS() && installPrompt) {
			try {
				setIsInstalling(true)
				installPrompt.prompt()
				const choiceResult = await installPrompt.userChoice
				handleCloseModal()
				if (choiceResult.outcome === 'accepted') {
					setIsInstallApp(true)
					setInstallCompleted(true)
				} else {
					setIsInstallApp(false)
				}
			} catch (error) {
				console.error('Error during installation:', error)
			} finally {
				setIsInstalling(false)
			}
		} else if (isIOS()) {
			setIosImage(true)
		}
		sendGaPush({
			category: 'SaludContinuarediseno',
			action: 'Clicinstalacion',
			label: 'MejoratuExperiencia'
		})
	}

	// modal control
	// const today = moment().format('L')
	/* const isToday = !!(
    localStorage.getItem('isTodayInstall') && localStorage.getItem('isTodayInstall') === today
  ) */

	// const normalizeRegistrationDate = registrationDate && moment(registrationDate).format('L')
	// const isFirstSession = normalizeRegistrationDate && normalizeRegistrationDate !== today ? 2 : 1

	// const time = 10000 / isFirstSession

	/* useEffect(() => {
    if (isParQPublicPath) return null

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(() => {
        if (!isInstalledAndroid && !isInstallApp && !isToday) {
          handleShowModal(
            <Modal>
              <InstallModal closeModal={handleCloseModal} />
            </Modal>
          )
          localStorage.setItem('isTodayInstall', today)
          localStorage.setItem('isFirstSession', isFirstSession)
        }
      })
    }
  }, [isInstalledAndroid, installApp, isToday, isFirstSession]) */

	useEffect(() => {
		listenMatchMedia()

		const installHandler = getAllowInstallation()
		const installedHandler = getWasInstalled()

		return () => {
			// Cleanup
			if (installHandler) window.removeEventListener('beforeinstallprompt', installHandler)
			if (installedHandler) window.removeEventListener('appinstalled', installedHandler)
		}
	}, [])

	return {
		isInstallApp,
		isInstalledAndroid,
		isInstalling,
		installCompleted,
		installApp,
		iosImage
	}
}
